import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import Toggle from 'react-toggle'
import ImageCropper from '../../../common/ImageCropper/ImageCropper.js'
// import GroupCheckbox from '../../../common/GroupCheckbox/GroupCheckbox.js'

class TripCruiseAdd extends React.Component {
  state = {
    status: 'active',
    name_en: '',
    name_ar: '',
    img_en: '',
    img_ar: '',
    order: '',
    is_active: false,
    isSaving: false,
    isData: false,
    Edit: false,
    cruise_destinations_list: [],
    cruise_destinations: [],
  }

  componentDidMount() {
    this.getCruiseDestinations()
    setTimeout(() => {
      if (this.props.id) {
        this.getCruiseDetails()
      }
    }, 100)
  }

  getCruiseDestinations = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-all-destinations`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ cruise_destinations_list: res.data.data })
        }
      })
  }

  getCruiseDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-cruise-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const cruiseData = res.data.data
          this.setState({
            ...cruiseData,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event, name = '') => {
    if (name === 'cruise_destinations') {
      this.setState({ cruise_destinations: event })
    } else if (event?.target?.name === 'is_active') {
      this.setState({ [event.target.name]: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })
    if (imgKeyName == 'img_ar') {
      this.setState({ imgAr: URL.createObjectURL(e) })
    } else {
      this.setState({ imgEn: URL.createObjectURL(e) })
    }
  }

  onSaveData = () => {
    const formData = new FormData()
    formData.append('name_en', this.state.name_en)
    formData.append('name_ar', this.state.name_ar)
    formData.append('is_active', this.state.is_active)
    // formData.append('cruise_destinations', this.state.cruise_destinations)
    this.setState({ isData: true })

    if (this.state.img_en?.type) {
      formData.append('img_en', this.state.img_en, 'your_original_filename.jpeg')
    }
    if (this.state.img_ar?.type) {
      formData.append('img_ar', this.state.img_ar, 'your_original_filename.jpeg')
    }

    if (this.props.id) {
      formData.append('id', this.props.id)

      axios
        .put(Constant.getAPI() + '/trips/update-cruise', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Cruise has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/trips/add-cruise', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Cruise has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    id="name_en"
                    placeholder={`Cruise Name: English`}
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder={`Cruise Name: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
            {/* <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-12">
              <GroupCheckbox
                title={'Cruise Destinations'}
                list={this.state.cruise_destinations_list}
                displayKey={'name_en'}
                idKey={'id'}
                selected={this.state.cruise_destinations}
                onChange={(event) => this.handleChange(event, 'cruise_destinations')}
              ></GroupCheckbox>
            </div> */}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Is Active</label>
                <div className="col-sm-9">
                  <Toggle
                    name="is_active"
                    id="is_active"
                    onChange={this.handleChange}
                    checked={this.state.is_active}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: English</div>
                <div className="col-sm-5">
                  <div style={{ color: 'red', fontWeight: 'bold' }}>Image size should be 500*500</div>
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_en || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_en')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: Arabic</div>
                <div className="col-sm-5">
                  <div style={{ color: 'red', fontWeight: 'bold' }}>Image size should be 500*500</div>
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_ar || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_ar')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/trip-cruise`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default TripCruiseAdd
